// Builds the app's single AnnotationStore from runtime config. Swap the adapter
// here to change persistence (REST today, DICOM SR/ANN export later) — no other
// file changes.

import { getConfig } from '../config/runtimeConfig';
import type { AnnotationStore } from './AnnotationStore';
import { HttpAnnotationStore } from './adapters/HttpAnnotationStore';

let instance: AnnotationStore | null = null;

export function getAnnotationStore(): AnnotationStore {
  if (!instance) {
    instance = new HttpAnnotationStore(getConfig().apiRoot);
  }
  return instance;
}

/**
 * A share-link holder reads annotations from the share namespace: the server
 * mounts a read-only GET /annotations under /api/s/<shareId>, beside the
 * share's own dicom-web. Same contract as the data source binding: undone on
 * the way out.
 */
export function bindShareAnnotationStore(shareId: string): void {
  instance = new HttpAnnotationStore(`${getConfig().apiRoot}/s/${shareId}`);
}

export function resetAnnotationStore(): void {
  instance = null;
}
